import isEmpty from 'lodash.isempty'
import { STRATEGYBUILDER_SECTION_NAME } from '../apollo/queries/GET_TEMPLATE_OVERVIEW'
import { TEMPLATE_STATUS } from '../apollo/queries/SUBMIT_ANSWERS'
import getPersonaList from '../pages/utils/StrategyBuilderHelperFunctions'

export const mergeStrategyData = ({ overviewCards, templateData }) => {
  const mergedData = overviewCards?.map(card => {
    const template = templateData?.find(
      template => template.name === card.title
    )
    if (template) {
      return {
        id: template.id,
        name: template.name,
        url: card?.icon?.file?.url,
        isComplete: template.templateStatus === TEMPLATE_STATUS.COMPLETE,
        destinationUrl: card.destinationUrl,
      }
    }
    return false
  })
  if (mergedData) return mergedData.filter(Boolean)
  return []
}

export const formatBySection = data => {
  if (!isEmpty(data)) {
    const formattedData = data?.template?.sections?.map(section => {
      return data?.template?.questions
        ?.map(question => {
          const { answers, ...rest } = question
          if (question.sectionId === section.id) {
            return { ...rest, sectionName: section.name, answers }
          }
        })
        ?.filter(Boolean)
    })
    return formattedData
  }
}

export const getAnswersBySectionId = ({
  sectionId,
  steps,
  data,
  getAllData = false,
}) => {
  const sectionData = formatBySection(data)?.find(section => {
    for (let i = 0; i <= steps; i++) {
      if (section[i].sectionId === sectionId) {
        return section[i]
      }
    }
  })
  if (!isEmpty(sectionData))
    return [].concat.apply(
      [],
      !getAllData ? sectionData.map(step => step.answers) : sectionData
    )
}

export const getQuestionsBySectionId = ({ sectionId, steps, data }) => {
  const sectionData = formatBySection(data)?.find(section => {
    for (let i = 0; i <= steps; i++) {
      if (section[i].sectionId === sectionId) {
        return section[i]
      }
    }
  })
  if (!isEmpty(sectionData)) return sectionData
}

export const getAnswerByID = ({ answerId, sectionId, steps, data }) => {
  const answers = getAnswersBySectionId({ sectionId, steps, data })
  if (!isEmpty(answers)) {
    return answers.find(answer => {
      return answer.id === answerId
    })
  }
}

export const getSelectedAnswersBySectionId = ({ sectionId, steps, data }) => {
  const sectionData = formatBySection(data)?.find(section => {
    for (let i = 0; i <= steps; i++) {
      if (section[i].sectionId === sectionId) {
        return section[i]
      }
    }
  })
  const reduced = sectionData[0].answers.reduce((result, option) => {
    if (option.userSelectedAnswer) {
      result.push(option.text)
    }
    return result
  }, [])

  if (!isEmpty(sectionData)) return reduced
}

export const getSelectedAnswersByQuestionId = ({
  questionId,
  sectionId,
  steps,
  data,
}) => {
  const sectionData = formatBySection(data)?.find(section => {
    for (let i = 0; i <= steps; i++) {
      if (section[i].sectionId === sectionId) {
        return section[i]
      }
    }
  })
  let result = []
  sectionData?.forEach(section => {
    section?.answers?.forEach(option => {
      if (option.userSelectedAnswer && option.questionId === questionId) {
        return result.push({ sectionText: section.text, option })
      }
    })
  })

  return result
}

export const getRelatedQuestions = questions => {
  const relatedQuestions = {}

  questions?.forEach(({ id, validationTrigger, questionType }) => {
    if (validationTrigger !== null && questionType === 'series') {
      relatedQuestions[id] = validationTrigger.split(',')
    }
  })

  return relatedQuestions
}

export const parseDeliverables = deliverablesFromContentful => {
  let result = []
  deliverablesFromContentful?.edges?.forEach(p => {
    const processedPersona = {
      category: p.node?.category,
      name: p.node?.title,
      description: p.node?.description?.description,
      descriptionBrandPositioning:
        p.node?.descriptionBrandPositioning?.descriptionBrandPositioning,
      image: p.node?.image?.file?.url,
      investableAssets: p.node?.investableAssets,
      descriptionMarketingStrategies:
        p.node?.descriptionMarketingStrategies?.descriptionMarketingStrategies,
      url: p.node?.url?.file?.url,
    }
    result.push(processedPersona)
  })
  return result
}

export const findDeliverable = (
  allDeliverables,
  sectionName,
  deliverableName = ''
) => {
  if (allDeliverables) {
    if (sectionName && deliverableName) {
      return allDeliverables.find(
        d => d.category === sectionName && d.name === deliverableName
      )
    }
  }
  return null
}

export const getDeliverablesByCategory = ({ contentfulData, personaPlans }) => {
  const allDeliverables = parseDeliverables(contentfulData)
  return [
    {
      category: STRATEGYBUILDER_SECTION_NAME.TARGET_MARKET,
      deliverables: getPersonaList(
        allDeliverables,
        'strategy-builder-deliverables',
        personaPlans?.personaAndPlan?.persona
      ),
    },
    {
      category: STRATEGYBUILDER_SECTION_NAME.BRAND_POSITIONING,
      deliverables: getPersonaList(
        allDeliverables,
        'strategy-builder-deliverables',
        personaPlans?.personaAndPlan?.persona
      ),
    },
    {
      category: STRATEGYBUILDER_SECTION_NAME.MARKETING_PLAN,
      deliverables: findDeliverable(
        allDeliverables,
        STRATEGYBUILDER_SECTION_NAME.MARKETING_PLAN,
        personaPlans?.personaAndPlan?.plan
      )
        ? [
            findDeliverable(
              allDeliverables,
              STRATEGYBUILDER_SECTION_NAME.MARKETING_PLAN,
              personaPlans?.personaAndPlan?.plan
            ),
          ]
        : [],
    },
  ]
}
